import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState: DaypartMap = {};

const slice = createSlice({
  name: 'dayparts',
  initialState,
  reducers: {
    setDayparts(_state, action: PayloadAction<DaypartMap>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, () => initialState);
  },
});

export const { setDayparts } = slice.actions;
export default slice.reducer;
